import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * LinkedInRedirect component
 * This page instantly redirects visitors from /linkedin to the home page
 * Used to track visitors coming from LinkedIn in Vercel Analytics
 * No loading screen shown - appears seamless to users
 */
const LinkedInRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Immediate redirect - no delay, no loading screen
    // Vercel Analytics will still capture the /linkedin page view
    navigate("/", { replace: true });
  }, [navigate]);

  // Return null so nothing renders before redirect
  return null;
};

export default LinkedInRedirect;
